import loadable from '@loadable/component';
import { Spin } from 'platform-components/common';
import React from 'react';

export default loadable(() => import('./lesson-card'), {
    fallback: <Spin center />,
    resolveComponent: (components) => components.default,
});
